import { render } from "./deleteFilePopup.vue?vue&type=template&id=74d10a1e&ts=true"
import script from "./deleteFilePopup.vue?vue&type=script&lang=ts"
export * from "./deleteFilePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__